import {createSlice, current} from '@reduxjs/toolkit'
import {state_patcher} from "./base";


// each instance of hash or array even with same contents is not equal to another (unlike Python, like Ruby)
// to cut down on needless view refreshes, sending static empty objects when empty collection is needed.
const EMPTY_PLANS = []
const EMPTY_API_KEYS  = {}

export const cost_estimator = createSlice({
        name: 'cost_estimator',
        initialState: {
            loading_results: false,
            loading_api_keys: true, // on new view always reload
            loading_plans: false,  // turned true by api_keys, api_key_name_selected change
            api_keys: EMPTY_API_KEYS,
            api_keys_count: 0,
            api_key_name_selected: null,
            plans: EMPTY_PLANS,
            inputs_error_message: null,
        },
        reducers: {
            update_estimator_state: state_patcher,
        }
    },
)

export const {
    update_estimator_state,
} = cost_estimator.actions

export {
    EMPTY_PLANS,
    EMPTY_API_KEYS
}

export default cost_estimator.reducer
